import { useState } from "react";
import { useNavigate } from "react-router-dom";
import backendApi from "../api/backendApi";
import LoadingButton from "../components/LoadingButton";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      setSubmitting(true);
      const res = await backendApi.post("/auth/forgot-password", { email });
      // Expecting: { resetId, expiresInSec }
      const { resetId, expiresInSec } = res.data || {};
      navigate("/verify-otp", { state: { email, resetId, expiresInSec } });
    } catch (err) {
      setError("If the email is registered, an OTP has been sent.");
      navigate("/verify-otp", { state: { email } });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col h-full justify-center items-center">
      <div className="md:max-w-lg w-[calc(100vw-2rem)] p-6 bg-white shadow rounded-3xl">
        <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
        <p className="text-sm text-gray-600 mb-4">
          Enter your email and we’ll send a one-time passcode (OTP).
        </p>

        {error && <div className="text-red-600 text-sm mb-3">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            className="input w-full"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <LoadingButton type="submit" loading={submitting} variant="dark">
            Send OTP
          </LoadingButton>
          <button
            onClick={() => navigate("/")}
            className={
              "w-full py-2 bg-white text-black border rounded-xl font-semibold"
            }
          >
            Return
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
